fx.ns("shared", class EditorSaver extends fx.CrudSaver {

    constructor(model) {
        super(model); // 50 updates at the same time
    }

    onSaved(data) {
        // special case for columns that accept temporary ids, so we check if we have final id and update it
        // CreationElementContent as 2 temporary ids : pageid, content (in case of photo)
        if (data && !data.error) 
        {
            if (Object.keys(data).length > 0) 
            {
                for (let i = 0; i < this.lastUpdates.length; i++) 
                {
                    if (this.lastUpdates[i].model && this.lastUpdates[i].model._m == "CreationElementContent") 
                    {
                        if (data[this.lastUpdates[i].model.creation_element_id])
                            this.lastUpdates[i].model.creation_element_id = data[this.lastUpdates[i].model.creation_element_id];

                        if (this.lastUpdates[i].model.component_type == "photo" && data[this.lastUpdates[i].model.content])
                            this.lastUpdates[i].model.content = data[this.lastUpdates[i].model.content];
                    }
                }
            }
        }

        super.onSaved(data);
    }

    handle(action) {
        if (!action.model)
            return;

        // Exception : Photos are created and deleted by server, Editor only updates photos
        if (action.model._m == "Photo" && (action.type == "create" || action.type == "delete"))
            return;

        // Exception : Zoom is not saved on Server
        if (action.model._m == "Zoom")
            return;

        if (action.model._m == "InstagramPhotoModel" ||
            action.model._m == "FacebookPhotoModel" ||
            action.model._m == "GooglePhotoModel" ||
            action.model._m == "GoogleAlbumModel" ||
            action.model._m == "FacebookAlbumModel" ||
            action.model._m == "Album" ||
            action.model._m == "Settings" ||
            (action.model._m == "CustomColor" && action.impactsOnly("id")) ||
            (action.model instanceof models.CreationElementContent && action.model.component_type == "pagination") || // we don't store pagination components
            action.model instanceof repositories.BaseRepository)  // we don't store any updates made directly on BaseRepository
            return;


        super.handle(action);

    }

});